<template>
  <div class="news-card-wrapper pb-md-0" @click="navigateToNewsPost()">
    <div class="row">
      <div class="card-img-wrapper col-12 col-md-3 pb-3 pb-md-0">
        <img
          v-if="imgUrl"
          class="card-img mr-4"
          :src="imgUrl"
          :alt="postData.title"
          @error="handleImgLoadError"
        />
      </div>
      <div class="col-12 col-md-9 pl-md-1">
        <div>
          <news-card-details :date="postData.date" />
        </div>
        <div><h3>{{ postData.title }}</h3></div>
        <div v-if="showInterestTag" class="d-inline-block">
          <interest-tag :title="postData.topic" />
        </div>
        <div v-else class="d-inline-block">
          <categories-tag :categories="postData.categories" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";

import SharepointMixin from "@/mixins/SharepointMixin";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import NewsCardDetails from "../news/NewsCardDetails";
import InterestTag from "./InterestTag";
import CategoriesTag from "./CategoriesTag";

export default {
  name: "news-feed-card",
  props: ["postData", "showInterestTag"],
  mixins: [HomebaseMixpanelMixin, SharepointMixin],
  components: {
    NewsCardDetails,
    InterestTag,
    CategoriesTag
  },
  data() {
    return {
      CONSTANTS,
      imgUrl: CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL
    };
  },
  created() {
    this.initializeNewsCard();
  },
  methods: {
    async initializeNewsCard() {
      try {
        this.imgUrl = this.postData.imageUrl;
      } catch (e) {
        this.handleImgLoadError();
      }
    },

    navigateToNewsPost() {
      let title = this.postData.title;
      let url = this.postData.url;
      let subevent = `${title} - ${url}`;
      this.trackNewsByInterestStoryClick(subevent);
      window.open(url, Vue.prototype.$getAoneLinkTarget(url));
    },

    handleImgLoadError() {
      this.imgUrl = CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL;
    },
  },
};
</script>

<style scoped>
.news-card-wrapper:hover {
  cursor: pointer;
}
.card-img-wrapper {
  height: 120px;
}
.card-img {
  border-radius: 5px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.card-title {
  font-size: 22px !important;
  font-family: artifaktElementBold !important;
  color: #000000 !important;
}
</style>
